module.exports = __webpack_public_path__ + "static/media/Angular.7cee765d.jpg";